jQuery(document).ready(function( $ ) {

    if ($('.vc_widget_sidebar .widget_rss').length > 1 ){
        $('.vc_widget_sidebar .widget_rss').last().addClass('rss-bongda');
    }

    if ($('.td-ss-main-sidebar .widget_rss').length > 1 ){
        $('.td-ss-main-sidebar .widget_rss').last().addClass('rss-bongda');
    }

});

/**
 * For facebook widget
 */
//
// jQuery(document).ready(function( $ ) {
//     $('.fb_loader').append('<div class="td-loader-gif td-loader-animation-start"></div>');
//
//     setTimeout(function () {
//         $('.fb_loader .td-loader-gif').removeClass('td-loader-animation-start').addClass('td-loader-animation-mid');
//         tdLoadingBox.init('#bf1e2d');
//     }, 50);
// });
